import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';
import {tap} from 'rxjs/operators';
import {AddTriggerQueryRequest} from '@models/adminstration/machine/trigger/trigger-query/add-trigger-query-request';
import {Trigger} from '@models/adminstration/machine/trigger/trigger';
import {
  UpdateTriggerQueryRequest
} from '@models/adminstration/machine/trigger/trigger-query/update-trigger-query-request';
import { HttpClient } from '@angular/common/http';
import {ApiLocationService} from '@services/api-location/api-location.service';

@Injectable({
  providedIn: 'root'
})
export class MachineGroupTriggerQueryService {

  private MACHINE_GROUP_TRIGGER_QUERY_URL_SUFFIX = '/api/web/admin/machinegroup/:id/triggerQuery';
  private MACHINE_GROUP_TRIGGER_QUERY_DELETE_URL_SUFFIX = '/api/web/admin/machinegroup/:id/triggerQuery?queryId=:qId';

  private readonly BASE_URL: string;
  private triggerQueryCache = new Map();

  constructor(
    private http: HttpClient,
    private apiLocation: ApiLocationService,
  ) {
    this.BASE_URL = this.apiLocation.getLocation();
  }

  public machineGroupTriggerQueryList(machineGroupId: number): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_GROUP_TRIGGER_QUERY_URL_SUFFIX;
    url = url.replace(':id', String(machineGroupId));
    const cache = this.triggerQueryCache.get(machineGroupId);
    if (cache) {
      return of(cache);
    }

    return this.http.get(url, HTTPS_REQUEST_OPTIONS).pipe(tap(value => this.triggerQueryCache.set(machineGroupId, value)));
  }

  public machineGroupTriggerQueryDelete(machineGroupId: number, triggerQueryId: number): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_GROUP_TRIGGER_QUERY_DELETE_URL_SUFFIX;
    url = url.replace(':id', String(machineGroupId)).replace(':qId', String(triggerQueryId));
    return this.http.delete(url, HTTPS_REQUEST_OPTIONS).pipe(tap(() => this.triggerQueryCache.delete(machineGroupId)));
  }

  public machineGroupTriggerQueryAdd(parentId: number, request: AddTriggerQueryRequest): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_GROUP_TRIGGER_QUERY_URL_SUFFIX;
    url = url.replace(':id', String(parentId));
    return this.http.post<Trigger>(url, request, HTTPS_REQUEST_OPTIONS);
  }

  public machineGroupTriggerQueryUpdate(parentId: number, request: UpdateTriggerQueryRequest): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_GROUP_TRIGGER_QUERY_URL_SUFFIX;
    url = url.replace(':id', String(parentId));
    return this.http.post<Trigger>(url, request, HTTPS_REQUEST_OPTIONS);
  }
}
